import { render } from "./TableModal.vue?vue&type=template&id=0b070262&scoped=true"
import script from "./TableModal.vue?vue&type=script&lang=js"
export * from "./TableModal.vue?vue&type=script&lang=js"

import "../../../../reports/css/modal.css?vue&type=style&index=0&id=0b070262&scoped=true&lang=css"
import "./TableModal.vue?vue&type=style&index=1&id=0b070262&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b070262"]])

export default __exports__